import { editorHtml, editorText, installRichEditor, restoreSelection, selectionOffsets, setEditorHtml } from './rich-composer.js';

// Keep the version the agent actually reviewed separate from live workspace state.
export function draftBase(ticket) {
  return Number(ticket?.draft?.baseConversationVersion ?? ticket?.version ?? 0);
}
export function submissionFor(previous, ticketId, body) {
  const fingerprint = JSON.stringify({ ticketId, ...body });
  return previous?.fingerprint === fingerprint ? previous : { fingerprint, id: crypto.randomUUID() };
}
export function captureComposer(root = document) {
  const editor = root.querySelector('#composer-text');
  if (!editor) return null;
  const active = root.activeElement;
  return { text: editorText(editor), html: editorHtml(editor), to: root.querySelector('#composer-to')?.value, cc: root.querySelector('#composer-cc')?.value, bcc: root.querySelector('#composer-bcc')?.value, selection: selectionOffsets(editor), focused: active === editor, focusId: ['composer-text','composer-to','composer-cc','composer-bcc'].includes(active?.id) ? active.id : null, editorScrollTop: editor.scrollTop };
}
export function restoreComposer(saved, root = document) {
  if (!saved) return;
  for (const [selector, value] of [['#composer-to', saved.to], ['#composer-cc', saved.cc], ['#composer-bcc', saved.bcc]]) {
    const node = root.querySelector(selector); if (node && value !== undefined) node.value = value;
  }
  const editor = root.querySelector('#composer-text');
  if (editor) { installRichEditor(editor); if (saved.html !== undefined) setEditorHtml(editor, saved.html); else if (saved.text !== undefined) editor.value = saved.text; }
  if (editor && saved.editorScrollTop !== undefined) editor.scrollTop = saved.editorScrollTop;
  const focused = saved.focusId ? root.querySelector(`#${saved.focusId}`) : saved.focused ? editor : null;
  if (focused) { focused.focus({ preventScroll: true }); if (focused === editor) restoreSelection(editor, saved.selection); }
}
